export enum DebitFor {
    PARTNER = 'PARTNER',
    MERCHANT = 'MERCHANT',
}

export enum Platform {
    BUDDY = 'BUDDY',
    OTHER = 'OTHER',
}

export function parsePlatform(value: string): Platform | undefined {
    switch (value) {
        case 'BUDDY':
            return Platform.BUDDY;
        case 'OTHER':
            return Platform.OTHER;
        default:
            return undefined;
    }
}
